module.exports = __webpack_public_path__ + "img/Sebastian-Baeza-Gonzalez.76d6c278.jpg";